import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Joyride from 'react-joyride';
import {
  Card,
  Table,
  Button,
  Modal,
  Input,
  Typography,
  Space,
  Tooltip,
  Popconfirm,
  Row,
  Col
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  InstagramOutlined
} from '@ant-design/icons';

import { obterContratoPeloUsuario, editarCamposContrato } from '../actions/ContratoActions';
import { obterArrobasPeloContrato, editarArroba, adicionarArroba, deletarArroba } from '../actions/InstagramActions';
import { enviarEmail } from '../actions/EmailActions';
import { cadastrarAcao } from '../actions/AcaoActions';

const { Title, Text } = Typography;

class Instagram extends React.Component {

  state = {
    arrobas: [],
    arrobaSelecionado: {},
    run: false,
    showModalArroba: false,
    showModalExcluirArroba: false,
    steps: [
      {
        content: <div><h3>Bem-vindo(a) à página de perfis!</h3><p>Cadastre aqui os perfis do Instagram dos membros da comissão para divulgação dos convites.</p></div>,
        placement: 'center',
        target: '#boxInstagram'
      },
      {
        content: <div><h3>Lista de Perfis</h3><p>Aqui você visualiza todos os perfis já cadastrados.</p></div>,
        placement: 'bottom',
        target: '.ant-table-wrapper'
      },
      {
        content: <div><h3>Adicionar Novo</h3><p>Clique aqui para incluir um novo perfil do Instagram.</p></div>,
        placement: 'bottom',
        target: '#btnAdicionarPerfil'
      }
    ]
  }

  async componentDidMount() {
    if (this.props.usuario.tipo === "comissao") {
      if (localStorage.getItem("tutorialInstagram") === null) {
        this.setState({ run: true });
        localStorage.setItem("tutorialInstagram", true);
      }
      await this.props.obterContratoPeloUsuario(this.props.usuario.id);
      await this.iniciar();
    }
  }

  async iniciar() {
    await this.props.obterArrobasPeloContrato(this.props.contrato.id);
    if (this.props.arrobas.length > 0) {
      this.setState({ arrobas: this.props.arrobas });
    }
  }

  handleClickEditar = (arrobaSelecionado) => {
    this.setState({ arrobaSelecionado, showModalArroba: true });
  }

  async handleArroba() {
    const { arrobaSelecionado } = this.state;
    if (arrobaSelecionado.id) {
      await this.props.editarArroba(arrobaSelecionado);
    } else {
      let arroba = { ...arrobaSelecionado };
      if (arroba.descricao !== undefined && arroba.descricao.trim() !== "") {
        arroba.contrato = this.props.contrato.id;
        await this.props.adicionarArroba(arroba);
        await this.setState({arrobaSelecionado: {}, showModalArroba: false});
        await this.iniciar();
      }
    }
    this.setState({ arrobaSelecionado: {}, showModalArroba: false });
    await this.iniciar();
  }

  async removerArroba(id) {
    await this.props.deletarArroba(id);
    await this.iniciar();
  }

  render() {
    if (this.props.usuario.tipo === "formando") {
      return <Redirect to="/" />;
    }

    const columns = [
      {
        title: 'Perfil do Instagram',
        dataIndex: 'descricao',
        key: 'descricao',
        render: text => (
          <Space>
            <InstagramOutlined style={{ fontSize: '20px', color: '#E1306C' }} />
            <Text>{text}</Text>
          </Space>
        )
      },
      {
        title: 'Ações',
        key: 'action',
        align: 'right',
        render: (text, record) => (
          <Space size="middle">
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                onClick={() => this.handleClickEditar(record)}
              />
            </Tooltip>
            <Popconfirm
              title="Tem certeza que deseja remover este perfil?"
              onConfirm={() => this.removerArroba(record.id)}
              okText="Sim"
              cancelText="Não"
            >
              <Tooltip title="Remover">
                <Button danger icon={<DeleteOutlined />} />
              </Tooltip>
            </Popconfirm>
          </Space>
        ),
      },
    ];

    return (
      <div className="row" style={{ padding: '20px' }}>
        <Col span={24} md={{ span: 12, offset: 6 }}>
          <Card
            id="boxInstagram"
            title={<Title level={3} style={{ margin: 0 }}><InstagramOutlined /> Perfis do Instagram</Title>}
            bordered={false}
            style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: '8px' }}
            extra={
              <Button
                id="btnAdicionarPerfil"
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => this.setState({ showModalArroba: true, arrobaSelecionado: {} })}
                style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
              >
                Adicionar
              </Button>
            }
          >
            <Table
              dataSource={this.state.arrobas}
              columns={columns}
              rowKey="id"
              pagination={{ pageSize: 5 }}
              locale={{ emptyText: "Nenhum perfil cadastrado" }}
            />
          </Card>
        </Col>

        <Modal
          title={this.state.arrobaSelecionado.id ? "Editar Perfil" : "Novo Perfil"}
          visible={this.state.showModalArroba}
          onOk={this.handleArroba.bind(this)}
          onCancel={() => this.setState({ showModalArroba: false })}
          okText="Salvar"
          cancelText="Cancelar"
        >
          <div>
            <label style={{ marginBottom: 8, display: 'block' }}>Perfil do Instagram (@usuario)</label>
            <Input
              prefix={<InstagramOutlined />}
              placeholder="@usuario"
              value={this.state.arrobaSelecionado.descricao || ''}
              onChange={(e) => this.setState({ arrobaSelecionado: { ...this.state.arrobaSelecionado, descricao: e.target.value } })}
            />
          </div>
        </Modal>

        <Joyride
          steps={this.state.steps}
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: '#ff4d4f',
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    arrobas: state.instagram.todos
  }
}

export default connect(mapStateToProps, { obterArrobasPeloContrato, editarArroba, adicionarArroba, deletarArroba, editarCamposContrato, cadastrarAcao, enviarEmail, obterContratoPeloUsuario })(Instagram);
